import { useTranslation } from 'react-i18next';
import { cn } from '~/common/utils/styleUtil';
import { useRelatedArticles } from '~/features/catalog/routes/resources/RelatedArticlesRoute';
import { ArticleSlider } from '~/common/components/ArticleSlider';

export interface RelatedProductsProps {
  className?: string;
  articleNumber: string;
  agrId: number;
}

export function RelatedProducts({ className, articleNumber, agrId }: Readonly<RelatedProductsProps>) {
  const { t } = useTranslation();
  const { articles } = useRelatedArticles(articleNumber, agrId);

  if(articles?.length === 0) {
    return null;
  }

  return (
    <div className={cn(className)}>
      <h2 className={'block text-xl font-bold mb-4'}>{t('Ähnliche Produkte')}</h2>
      <ArticleSlider articles={articles} />
    </div>
  );
}
